import { __decorate } from "tslib";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DashboardRoutingModule } from "./dashboard-routing.module";
import { MatGridListModule } from "@angular/material/grid-list";
import { SharedModule } from "../../shared/shared.module";
import { DisclaimerDialogBodyComponent } from "./disclaimer-dialog-body/disclaimer-dialog-body.component";
import { MatDialogModule } from "@angular/material/dialog";
import { DashboardComponent } from "./dashboard.component";
let DashboardModule = class DashboardModule {
};
DashboardModule = __decorate([
    NgModule({
        declarations: [DisclaimerDialogBodyComponent, DashboardComponent],
        imports: [
            CommonModule,
            DashboardRoutingModule,
            MatGridListModule,
            SharedModule,
            MatDialogModule
        ]
    })
], DashboardModule);
export { DashboardModule };
